// --- Dependencies -------------------------------------------------------------------------------
import { MuiTelInput } from "mui-tel-input";
// --- Our Modules --------------------------------------------------------------------------------
import "../field.css";
import "./styles.css";
// --- Logic --------------------------------------------------------------------------------------
type Props = {
    value: string | undefined;
    onChange: (value: string | undefined) => void;
    label?: string;
    placeholder?: string;
    disabled?: boolean;
    error?: string | null;
};

/**
 * The one place MUI is allowed: a country picker with flags and per-country formatting is not worth
 * hand-writing. `forceCallingCode` keeps `+966` fixed, so what reaches the API is already E.164.
 */
export default function PhoneInput({ value, onChange, label, placeholder, disabled, error }: Props) {
    return (
        <MuiTelInput
            // `mui-tel-input` is a `TextField` underneath, so it takes the same floating label and
            // the same skin as every other field — see `field.css`.
            className={`field phone-input${error ? " phone-input--error" : ""}`}
            defaultCountry="SA"
            forceCallingCode
            value={value ?? ""}
            onChange={(newValue) => onChange(newValue)}
            label={label}
            placeholder={label ? undefined : placeholder}
            disabled={disabled}
            error={!!error}
            helperText={error || undefined}
            fullWidth
        />
    );
}
